const CheckConnectionStates = {
    init: 'init',
    ask: 'ask',
    inProgress: 'inProgress',
    ready: 'ready',
};
export default CheckConnectionStates;
